import { useEffect, useState } from 'react';
import '../css/App.css';
import about from '../aboutDescription.js';
import StorefrontLayout from './StorefrontLayout';
import InstagramFeed from './InstagramFeed';

const About = () => {
    const [cardFlipped, setCardFlipped] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <StorefrontLayout>
            <main className="aboutPage">
                <header className="aboutHero">
                    <p className="aboutKicker">About</p>
                    <h1 className="aboutPageTitle">{about.name}</h1>
                    <p className="aboutPageRole">
                        {about.role}
                        <span aria-hidden="true"> · </span>
                        {about.location}
                    </p>
                </header>

                <section className="aboutIntro">
                    <figure className="aboutPortrait">
                        <img className="aboutPageImage" src="/images/about/about.jpg?v=2" alt="Delaney Stewart in the studio" />
                    </figure>
                    <div className="aboutCopy">
                        <p className="aboutLead">{about.lead}</p>
                        {about.bio.map((paragraph) => (
                            <p className="aboutPageBody" key={paragraph.slice(0, 32)}>{paragraph}</p>
                        ))}
                        <button
                            type="button"
                            className={cardFlipped ? 'aboutCard aboutCardFlipped' : 'aboutCard'}
                            onClick={() => setCardFlipped((open) => !open)}
                            aria-label={cardFlipped ? 'Flip business card to the front' : 'Flip business card'}
                            aria-pressed={cardFlipped}
                        >
                            <span className="aboutCardInner">
                                <img
                                    className="aboutCardFace aboutCardFront"
                                    src="/images/about/card-front.png"
                                    alt="Delaney Stewart crest"
                                />
                                <img
                                    className="aboutCardFace aboutCardBack"
                                    src="/images/about/card-back.png"
                                    alt="Delaney Stewart, artist and printmaker. (760) 845-8060, delaney@stewartsurety.com, delaneystewart.com, @dnystu"
                                />
                            </span>
                        </button>
                    </div>
                </section>

                <section className="aboutLists">
                    <div className="aboutListBlock">
                        <h2 className="aboutListTitle">Education</h2>
                        <ul className="aboutList">
                            {about.education.map((entry) => (
                                <li key={entry.place}>
                                    <p className="aboutListName">{entry.place}</p>
                                    <p className="aboutListDetail">{entry.detail}</p>
                                    <p className="aboutListMeta">{entry.where} · {entry.when}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="aboutListBlock">
                        <h2 className="aboutListTitle">Exhibitions &amp; Awards</h2>
                        <ul className="aboutList">
                            {about.exhibitions.map((entry) => (
                                <li key={entry.title}>
                                    <p className="aboutListName">{entry.title}</p>
                                    <p className="aboutListDetail">{[entry.kind, entry.venue].filter(Boolean).join(' · ')}</p>
                                    <p className="aboutListMeta">{entry.where} · {entry.when}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                <InstagramFeed className="aboutInstagram" />
            </main>
        </StorefrontLayout>
    );
};

export default About;
